<script setup>
import { computed, onMounted, ref, nextTick, defineEmits } from 'vue';

import { xios } from '../forms/tempAxios';
import { Notify } from 'quasar';

import TmsTable from '../table/TmsTable.vue';

// Define emits to update parent component
const emit = defineEmits(['update:selected']);

const columnsType = [
  {
    name: 'firstName',
    label: 'First Name',
  },
  {
    name: 'lastName',
    label: 'Last Name',
  },
  {
    name: 'email',
    label: 'Email',
  },
  {
    name: 'licenseNumber',
    label: 'License No.',
  },
  {
    name: 'dateOfBirth',
    label: 'DOB',
  },
  {
    name: 'phone',
    label: 'Phone No',
  },
  ,
];

const columns = computed(() => {
  let arr = [];
  columnsType.forEach((e) => {
    e.align = 'left';
    e.field = e.name;
    arr.push(e);
  });
  return arr;
});

const data = ref([]);

onMounted(async () => {
  await nextTick();
  data.value = await fetchData();
  console.log(data.value);
});

async function fetchData() {
  try {
    const res = await xios.post('api-tms/script-pagination-standard', {
      model: 'Driver',
      page: 1,
      itemsPerPage: 10,
      filterFields: [
        {
          field: 'status',
          operator: 'eq',
          value: 1,
        },
        {
          field: 'clientId',
          operator: 'eq',
          value: JSON.parse(localStorage.getItem('userInfo')).uid,
        },
      ],
      // includeModels: [
      //   {
      //     model: 'TripDriverAssignment',
      //     as: 'trip_driver_assignments', // Use the association alias if defined
      //   },
      // ],
      attributesInclude: [],
      sortBy: 'licenseExpiry',
      orderBy: 'ASC',
    });
    if (res.data.success) {
      return res.data.data.items;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}
function editDriver(driverData) {
  if (!driverData || !driverData.id) {
    console.error('Invalid driver data passed to editDriver:', driverData);
    Notify.create({
      message: 'Could not edit driver: Invalid driver data',
      color: 'negative',
    });
    return;
  }

  console.log(`Editing driver with ID: ${driverData.id}`);

  // Store driver ID in localStorage to be retrieved by CreateDriver component
  localStorage.setItem('currentDriverId', driverData.id);

  // Emit event to parent component to update the selected view
  emit('update:selected', 'Create Driver');
}
</script>

<template>
  <TmsTable
    :data="data"
    :selected="$attrs.selected"
    :columns="columns"
    :action="editDriver"
    row-key="id"
  />
</template>
